/* tslint:disable */
/* eslint-disable */
export enum WorkMyTodoTypeEnum {
  Task = 'task',
  ProjectRequest = 'projectRequest',
  Todo = 'todo'
}
